import styled, { keyframes } from 'styled-components';

/* === Animations === */
const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

/* === Conteneur principal des macros === */
export const MacrosContainer = styled.div`
  display: flex;
  width: 100%;
  min-width: 0;
  gap: 0.5rem;
  flex-wrap: wrap;
  margin-bottom: 0.625rem;
  animation: ${fadeInUp} 0.4s ease forwards;

  @media (max-width: 640px) {
    gap: 0.24rem;
    margin-bottom: 0.3rem;
  }
`;

/* === Chaque “pillule” de macro === */
export const MacroPill = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 0;
  padding: 0.5rem;
  background: var(--gris-clair);
  border-radius: 6px;
  flex: 1 1 120px;
  border: 1px solid #e1e5e9;

  @media (max-width: 640px) {
    flex: 1 1 calc(50% - 0.2rem);
    padding: 0.38rem 0.44rem;
    border-radius: 7px;
  }
`;

/* Label de la macro (P / G / L) */
export const MacroLabel = styled.div`
  width: 100%;
  font-size: 0.7rem;
  color: #666;
  font-weight: 600;
  margin-bottom: 0.125rem;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media (max-width: 640px) {
    font-size: 0.74rem;
    line-height: 1.2;
    white-space: normal;
  }
`;

/* Valeur de la macro (ex: 12.5g) */
export const MacroAmount = styled.div`
  width: 100%;
  font-size: 0.8rem;
  font-weight: 700;
  color: var(--bleu-mineral);
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  /* width: 100%; */

  @media (max-width: 640px) {
    font-size: 0.82rem;
    line-height: 1.2;
  }
`;

export const DetailPreview = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
`;

export const DetailPreviewChip = styled.div`
  background: #f0f4f8;
  color: #4a5568;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  padding: 0.25rem 0.6rem;
  font-size: 0.75rem;
  font-weight: 500;
  line-height: 1.2;
`;

/* === Détails nutritionnels (traduction de Journal.css) === */
export const NutritionDetails = styled.div`
  margin-top: 0.625rem;
  width: 100%;
  padding: 0.875rem;
  background: var(--gris-clair);
  border-radius: 6px;
  border: 1px solid #e1e5e9;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.5rem;
  animation: ${fadeInUp} 0.35s ease forwards;

  @media (max-width: 640px) {
    padding: 0.62rem;
    border-radius: 8px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.42rem;
  }

  @media (max-width: 430px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const NutritionItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-width: 0;
  gap: 0.3rem;
  padding: 0.5rem;
  background: white;
  border-radius: 4px;
  border: 1px solid #e1e5e9;

  @media (max-width: 640px) {
    padding: 0.46rem 0.5rem;
    border-radius: 6px;
  }
`;

export const NutritionLabel = styled.span`
  font-weight: 500;
  color: var(--gris-fonce);
  font-size: 0.8rem;
  flex: 1;

  @media (max-width: 640px) {
    font-size: 0.78rem;
    line-height: 1.25;
    min-width: 0;
    white-space: normal;
  }
`;

export const NutritionValue = styled.span`
  font-weight: 600;
  color: ${({ $missing }) => ($missing ? '#7b8794' : 'var(--bleu-mineral)')};
  font-size: 0.8rem;
  min-width: 0;
  flex-shrink: 0;
  text-align: right;
  font-style: ${({ $missing }) => ($missing ? 'italic' : 'normal')};

  @media (max-width: 640px) {
    font-size: 0.78rem;
    line-height: 1.25;
  }
`;

export const NutritionSectionTitle = styled.div`
  width: 100%;
  font-size: 0.78rem;
  font-weight: 700;
  color: #5f7286;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-top: 0.1rem;
  margin-bottom: -0.15rem;

  @media (max-width: 640px) {
    font-size: 0.76rem;
    margin-bottom: 0.08rem;
  }
`;

/* === Bouton pour afficher/masquer les détails === */
export const NutritionDetailBtn = styled.button`
  background: none;
  border: none;
  color: var(--bleu-mineral);
  cursor: pointer;
  font-size: 0.84rem;
  font-weight: 700;
  padding: 0.5rem 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.38rem;
  transition: color 0.2s ease;
  width: 100%;
  border-radius: 4px;

  @media (max-width: 640px) {
    font-size: 0.82rem;
    padding: 0.42rem 0;
  }

  &:hover {
    color: var(--vert-vitalite);
  }

  &.active {
    color: var(--vert-vitalite);
  }

  svg {
    width: 18px;
    height: 18px;
    transition: transform 0.2s ease;
    flex-shrink: 0;
    overflow: visible;
  }

  &.active svg {
    transform: rotate(180deg);
  }
`;
